import React, { useContext, useEffect, useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencilAlt } from "@fortawesome/free-solid-svg-icons";

import Loader from "../../loader/loader";

import { ShotContext } from "../context/index";
import { Checkbox } from "components/form-inputs/inputs";
import { useFileType } from "../../../shared/hooks/use-file-type";
import { isValidMultiple } from "../../form-inputs/imageUploader/lib/fileHelper";
import { ImagePopout } from "components/image-stream/image-popout";
import { TaskContext } from "contexts/task";

const EditImage = ({ isCoding, isCompleted, isFinalized, zipUpload, ...props }) => {
    const fileInputRef = useRef();
    const fileType = useFileType(zipUpload);
    const { imageViewCode, imageViewDescription, key, uneditedBlobKey, uneditedImageUris, isUploading, isSelected } = props.photo;
    const { task } = useContext(TaskContext);
    const { updateImage, updateProperty, updateZipFile } = useContext(ShotContext);
    const [timestamp, setTimestamp] = useState(Math.round(new Date().getTime() / 1000));
    const isEditAvailable = isCoding && !isFinalized && isCompleted ? true : !isCompleted;

    useEffect(() => {
        setTimestamp(Math.round(new Date().getTime() / 1000));
    }, [uneditedBlobKey]);

    const openFilePicker = () => {
        fileInputRef.current.click();
    };

    const onFileChange = () => {
        const validFiles = isValidMultiple(fileInputRef.current.files, fileType);

        if (!validFiles || validFiles.length === 0) {
            return false;
        }

        return uploadFile(fileInputRef.current.files[0]);
    };

    const uploadFile = (file) => {
        const formData = new FormData();
        formData.append("file", file);
        formData.append("imageView", imageViewCode);
        formData.append("awaitThumbnailCreation", true);
        formData.append("imageType", 1);

        if (zipUpload) {
            return updateZipFile(file, imageViewCode, key);
        }

        updateImage(formData, key);
    };

    const handleSelect = (name, value) => {
        updateProperty([key], name, value, false);
    };

    const ImageOrLoading = () => {
        if (isUploading) {
            return <Loader />;
        }

        if (isEditAvailable) {
            return (
                <img
                    id={`img_${props.wipKey}_${key}`}
                    onMouseDown={(e) => {
                        e.preventDefault();
                    }}
                    alt={`Product ${imageViewDescription || "Coding"}`}
                    src={uneditedImageUris ? `${uneditedImageUris.medium}?v=${timestamp}` : ""}
                />
            );
        }

        return (
            <ImagePopout
                photoKey={`img_${props.wipKey}_${key}`}
                imageUris={uneditedImageUris ? uneditedImageUris : { small: "", medium: "", normal: "" }}
                alt={`Product ${imageViewDescription || "Coding"}`}
                shipmentKey={task.context.shipmentKey}
                shipmentProductKey={task.context.shipmentProductKey}
                imageSize="medium"
                timeStamp={timestamp}
            />
        );
    };

    return (
        <div className={`edit-image rotate${props.rotation}`}>
            {isEditAvailable && !props.isReadOnly && (
                <div
                    className="edit-button"
                    onClick={openFilePicker}
                >
                    <FontAwesomeIcon icon={faPencilAlt} />
                </div>
            )}
            {props.showBulkSelect && (
                <div className="select-button">
                    <Checkbox
                        name="isSelected"
                        updateOnChange={handleSelect}
                        value={isSelected}
                    />
                </div>
            )}
            <div className="hide">
                <input
                    type="file"
                    onChange={onFileChange}
                    accept={fileType}
                    ref={fileInputRef}
                    disabled={props.isReadOnly}
                />
            </div>
            <div className="image-block">
                <ImageOrLoading />
            </div>
        </div>
    );
};

export default EditImage;
